import axios from 'axios';
import qs from 'qs'

// const ajaxBaseUrl = 'http://192.168.0.85:7000';
// const ajaxBaseUrl = 'http://192.168.0.85:7104';
// const ajaxBaseUrl = 'http://192.168.0.45:30700';
// const ajaxBaseUrl = 'http://113.219.246.33:30700';
const ajaxBaseUrl = 'http://113.219.246.33:31700';
// const ajaxBaseUrl = 'http://192.168.0.45:7000';
// const ajaxBaseUrl = 'http://113.219.246.33:8485';

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '' : ajaxBaseUrl

export default axios